import React, { useState } from "react";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createNewTicket } from "../utilities/userauth";
import { useNavigate } from "react-router-dom";

export const AddTicket = () => {
  const navigate = useNavigate();
  const {
    user: { name, _id },
  } = useSelector((state) => state.userinfo);

  const initialField = {
    status: "open",
    date: null,
    comment: "",
  };

  const [field, setField] = useState(initialField);

  const FieldchangeHandler = (e) => {
    const { name, value } = e.target;

    setField({ ...field, [name]: value });
  };

  //sending data
  const senderobject = {
    subject: field.Subject,
    message: field.comment,
    sender: name,
  };

  const SubmitAddTicket = (e) => {
    e.preventDefault();
    console.log(field);
    // semdding the message for savuing the data for generatign the new ticket
    const newTicket = createNewTicket(senderobject);

    if (newTicket) {
      alert(
        "New Ticket Created ! We will try to solve your issue as soon as possible!"
      );
    }
    navigate("/dashboard");
  };

  return (
    <Container>
      <Row>
        <h3>Add Ticket Page</h3>
        <Col>
          <Form onSubmit={SubmitAddTicket}>
            <Form.Group>
              <Form.Label>status</Form.Label>
              <Form.Control
                type="text"
                name="status"
                value={field.status}
                placeholder="Email"
                onChange={FieldchangeHandler}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                name="Subject"
                value={field.Subject}
                placeholder="Email"
                onChange={FieldchangeHandler}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Comment</Form.Label>
              <Form.Control
                type="textarea"
                name="comment"
                value={field.comment}
                placeholder="please type you message here ........"
                onChange={FieldchangeHandler}
              />
              <Button type="submit" className="mt-2">
                Submit
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
